module.exports = __webpack_public_path__ + "static/img/fish4.1f8f121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish4.png
// module id = kuQQ
// module chunks = 0